const DropdownOptions = {
  OriginTypeSelection: [
    { name: "Field", id: "1" },
    { name: "On-Site", id: "2" }
  ],
  contractStage: [
    { name: "Proposal", id: "1" },
    { name: "Agreed", id: "2" },
    { name: "Fulfilment", id: "3" },
    { name: "Complete", id: "4" },
    { name: "Cancelled", id: "5" }
  ],
  trucklineTypes: [
    { name: "Farm Owned Truck", id: 1 },
    { name: "External Truckline", id: 2 }
  ],
  harvestYears: [
    { name: "2022", id: "2022" },
    { name: "2023", id: "2023" },
    { name: "2024", id: "2024" },
   
  ],

  roleTypes: {
    SUPER_ADMIN: [
      { name: "Account Owner", id: "ACCOUNT_OWNER" },
      { name: "Account Admin", id: "ACCOUNT_ADMIN" },
      { name: "Farm Employee", id: "FARM_EMPLOYEE" }
    ],
    ACCOUNT_OWNER: [
      { name: "Account Admin", id: "ACCOUNT_ADMIN" },
      { name: "Farm Employee", id: "FARM_EMPLOYEE" }
    ],
    ACCOUNT_ADMIN: [{ name: "Farm Employee", id: "FARM_EMPLOYEE" }],
    FARM_EMPLOYEE: [{ name: "Farm Employee", id: "FARM_EMPLOYEE" }]
  },
  editRoleTypes: {
    SUPER_ADMIN: [
      { name: "Super Admin", id: "SUPER_ADMIN" },
      { name: "Account Owner", id: "ACCOUNT_OWNER" },
      { name: "Account Admin", id: "ACCOUNT_ADMIN" },
      { name: "Farm Employee", id: "FARM_EMPLOYEE" }
    ],
    ACCOUNT_OWNER: [
      { name: "Account Owner", id: "ACCOUNT_OWNER" },
      { name: "Account Admin", id: "ACCOUNT_ADMIN" },
      { name: "Farm Employee", id: "FARM_EMPLOYEE" }
    ],
    ACCOUNT_ADMIN: [
      { name: "Account Admin", id: "ACCOUNT_ADMIN" },
      { name: "Farm Employee", id: "FARM_EMPLOYEE" }
    ],
    FARM_EMPLOYEE: [
      { name: "Account Admin", id: "ACCOUNT_ADMIN" },
      { name: "Farm Employee", id: "FARM_EMPLOYEE" }
    ]
  },

  ALL_MAIN_FARM: { name: "All", id: "ALL_MAIN_FARM" },
  ALL_USERS: [
    { name: "All Users", id: "ALL_USERS" },
    { name: "Account Owner", id: "ACCOUNT_OWNER" },
    { name: "Account Admin", id: "ACCOUNT_ADMIN" },
    { name: "Farm Employee", id: "FARM_EMPLOYEE" }
  ],
  inventoryMgmt: {
    INCOMING_FILL_OPTION: [
      {
        name: "Incoming Est. Home Scale Shrunk Bushels",
        id: "incommingEstimatedHomeScaleShrinkBushels"
      },
      {
        name: "Incoming Field Est. Load Bushels",
        id: "incommingFieldEstimatedLoadBushels"
      }
    ],
    OUTGOING_FILL_OPTION: [
      {
        name: "Outgoing Est. Home Scale Shrunk Bushels",
        id: "outgoingEstimatedHomeScaleShrinkBushels"
      },
      {
        name: "Outgoing Field Est. Load Bushels",
        id: "outgoingFieldEstimatedLoadBushels"
      }
    ]
  }
};

export default DropdownOptions;



// WEBPACK FOOTER //
// ./src/constants/DropdownOptions.js